module.exports = __webpack_public_path__ + "static/media/lychee.d96fb0d4.svg";